// Campo de valor em reais. Guarda centavos; mostra o que a pessoa digitou até
// sair do campo, e então reformata. Reformatar a cada tecla atrapalha quem está
// no meio de digitar — o cursor pula e o valor "briga" com a digitação.

import { useEffect, useState } from "react";
import { deCentavos, paraCentavos } from "../lib/dinheiro.ts";

export function CampoDinheiro({
  valorCentavos,
  onMudar,
  id,
  placeholder = "0,00",
  disabled = false,
  prefixo = "R$",
}: {
  valorCentavos: string | null;
  onMudar: (centavos: string | null) => void;
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  /** O símbolo à esquerda: "R$", ou "US$" num valor em dólar. */
  prefixo?: string;
}) {
  const [texto, setTexto] = useState(() => deCentavos(valorCentavos));
  const [editando, setEditando] = useState(false);

  // Mantém o campo em dia quando o valor muda de fora (edição de linha
  // existente, limpeza do formulário) — mas nunca no meio da digitação.
  useEffect(() => {
    if (!editando) setTexto(deCentavos(valorCentavos));
  }, [valorCentavos, editando]);

  return (
    <div className="relative">
      <span className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-[13px] text-tinta-fraca">
        {prefixo}
      </span>
      <input
        id={id}
        type="text"
        inputMode="decimal"
        disabled={disabled}
        value={texto}
        placeholder={placeholder}
        onFocus={() => setEditando(true)}
        onChange={(e) => {
          setTexto(e.target.value);
          onMudar(paraCentavos(e.target.value));
        }}
        onBlur={() => {
          setEditando(false);
          setTexto(deCentavos(paraCentavos(texto)));
        }}
        className="num w-full rounded-lg border border-linha bg-superficie py-2 pr-3 pl-9 text-right text-[14px] disabled:bg-superficie-2 disabled:text-tinta-fraca"
      />
    </div>
  );
}
